import React from 'react';

import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Textarea,
} from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

import { CustomText } from '@components/Custom-text';

interface FormControlTextAreaProps {
    name: string;
    label: string;
    placeholder: string;
    isDisabled?: boolean;
    isRequired?: boolean;
    handleFieldOnChange?: (name: string, value: string) => void;
}

const FormControlTextArea: React.FC<FormControlTextAreaProps> = ({
    name,
    label,
    placeholder,
    isDisabled,
    isRequired,
    handleFieldOnChange,
}) => (
    <Field name={name}>
        {({ field, form: { touched, values, errors, setFieldValue, handleBlur } }: FieldProps) => {
            const isInvalid = !!errors[field.name] && touched[field.name];
            return (
                <FormControl isInvalid={Boolean(isInvalid)}>
                    <Flex>
                        <FormLabel>
                            <Heading color="titleText" size="xs" as="h6">
                                {label}
                            </Heading>
                        </FormLabel>
                        {isRequired ? (
                            <Heading color="red" size="xs" ml={-2}>
                                *
                            </Heading>
                        ) : null}
                    </Flex>
                    <Textarea
                        {...Field}
                        name={name}
                        placeholder={placeholder}
                        isDisabled={isDisabled}
                        resize="vertical"
                        isInvalid={Boolean(isInvalid)}
                        onBlur={handleBlur}
                        value={field.value}
                        onChange={e => {
                            setFieldValue(name, e.target.value);
                            handleFieldOnChange?.(name, e.target.value);
                        }}
                    />
                    <FormErrorMessage>
                        <CustomText size="xs" color="red.500">
                            {String(errors[field.name])}
                        </CustomText>
                    </FormErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default FormControlTextArea;
